// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*----------> START Patient TAB <------------*/


.patient-tabs {
    font-family: 'Montserrat', sans-serif; /* Default font */
}
.patient-tabs .p-tabview-panels {
    background: transparent;
    height: 90%;
}
.patient-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{
    border-width: 0 0 0px;
}
.patient-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link{
    border-width: 0 0 5px;
    border-color: var(--blue);
    padding-bottom: 20px;
    margin-bottom: -4px;
}
.patient-tabs .p-tabview ul.p-tabview-nav{
    border-width: 0 0 3px 0;
    border-color:white;
}
.patient-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link,
.patient-tabs .p-tabview ul.p-tabview-nav{
    background: transparent !important;
    color: white;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 300;
    font-family: 'Montserrat', sans-serif; /* Default font */
    margin-bottom: 2px;
}

.patient-tabs .p-tabview ul.p-tabview-nav li{
    opacity: 0.8;
}

.patient-tabs .p-tabview ul.p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,
.patient-tabs .p-tabview ul.p-tabview-nav li:hover a.p-tabview-nav-link,
.patient-tabs .p-tabview ul.p-tabview-nav li.p-highlight > a.p-tabview-nav-link{
    opacity: 1;
    color: white;
}
.patient-tabs .p-tabview ul.p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {
    box-shadow: none;
}

.patient-tabs .p-tabview .p-tabview-panels  {
    padding-left: 0;
    padding-right: 0;
}

.patient-tabs .details-tab{
    font-family: 'Montserrat', sans-serif; /* Default font */
}
/*----------> END Patient TAB <------------*/


/*----------> START Distance TAB <------------*/

.distances-tabs .p-tabview ul.p-tabview-nav{
    padding: 10px 0px;
}
.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link,
.distances-tabs .p-tabview ul.p-tabview-nav{
    font-size: 12px;
    font-weight: bold;
    opacity: 1;
    border: none;
}

.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{
    padding: 10px 20px;
}

.distances-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link,
.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{
    border-width: 1px 1px 1px 1px;
    padding: 10px 20px;
}

.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{
    border: 1px solid transparent;
    border-radius: 15px;
    margin-right: 10px;
}

.distances-tabs .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,
.distances-tabs .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,
.distances-tabs .p-tabview ul.p-tabview-nav li:hover a.p-tabview-nav-link,
.distances-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link
{
    color: var(--blue) !important;
    border-color: var(--blue);
    transition: 0.3s;
    background-color: rgb(75, 196, 236, 0.31) !important;
}
/*----------> END Distance TAB <------------*/
`, "",{"version":3,"sources":["webpack://./src/css/tabs.css"],"names":[],"mappings":";AACA,8CAA8C;;;AAG9C;IACI,qCAAqC,EAAE,iBAAiB;AAC5D;AACA;IACI,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;;IAEI,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC,EAAE,iBAAiB;IACxD,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC,EAAE,iBAAiB;AAC5D;AACA,4CAA4C;;;AAG5C,+CAA+C;;AAE/C;IACI,iBAAiB;AACrB;AACA;;IAEI,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;;;IAKI,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,oDAAoD;AACxD;AACA,6CAA6C","sourcesContent":["\n/*----------> START Patient TAB <------------*/\n\n\n.patient-tabs {\n    font-family: 'Montserrat', sans-serif; /* Default font */\n}\n.patient-tabs .p-tabview-panels {\n    background: transparent;\n    height: 90%;\n}\n.patient-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{\n    border-width: 0 0 0px;\n}\n.patient-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link{\n    border-width: 0 0 5px;\n    border-color: var(--blue);\n    padding-bottom: 20px;\n    margin-bottom: -4px;\n}\n.patient-tabs .p-tabview ul.p-tabview-nav{\n    border-width: 0 0 3px 0;\n    border-color:white;\n}\n.patient-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link,\n.patient-tabs .p-tabview ul.p-tabview-nav{\n    background: transparent !important;\n    color: white;\n    font-size: 14px;\n    text-transform: uppercase;\n    font-weight: 300;\n    font-family: 'Montserrat', sans-serif; /* Default font */\n    margin-bottom: 2px;\n}\n\n.patient-tabs .p-tabview ul.p-tabview-nav li{\n    opacity: 0.8;\n}\n\n.patient-tabs .p-tabview ul.p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,\n.patient-tabs .p-tabview ul.p-tabview-nav li:hover a.p-tabview-nav-link,\n.patient-tabs .p-tabview ul.p-tabview-nav li.p-highlight > a.p-tabview-nav-link{\n    opacity: 1;\n    color: white;\n}\n.patient-tabs .p-tabview ul.p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus {\n    box-shadow: none;\n}\n\n.patient-tabs .p-tabview .p-tabview-panels  {\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.patient-tabs .details-tab{\n    font-family: 'Montserrat', sans-serif; /* Default font */\n}\n/*----------> END Patient TAB <------------*/\n\n\n/*----------> START Distance TAB <------------*/\n\n.distances-tabs .p-tabview ul.p-tabview-nav{\n    padding: 10px 0px;\n}\n.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link,\n.distances-tabs .p-tabview ul.p-tabview-nav{\n    font-size: 12px;\n    font-weight: bold;\n    opacity: 1;\n    border: none;\n}\n\n.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{\n    padding: 10px 20px;\n}\n\n.distances-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link,\n.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{\n    border-width: 1px 1px 1px 1px;\n    padding: 10px 20px;\n}\n\n.distances-tabs .p-tabview ul.p-tabview-nav li a.p-tabview-nav-link{\n    border: 1px solid transparent;\n    border-radius: 15px;\n    margin-right: 10px;\n}\n\n.distances-tabs .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,\n.distances-tabs .p-tabview .p-tabview-nav li:not(.p-highlight):not(.p-disabled):hover .p-tabview-nav-link,\n.distances-tabs .p-tabview ul.p-tabview-nav li:hover a.p-tabview-nav-link,\n.distances-tabs .p-tabview ul.p-tabview-nav li.p-highlight a.p-tabview-nav-link\n{\n    color: var(--blue) !important;\n    border-color: var(--blue);\n    transition: 0.3s;\n    background-color: rgb(75, 196, 236, 0.31) !important;\n}\n/*----------> END Distance TAB <------------*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
